<div class="backButton" [style.color]="buttonColor" (click)="doBack()" [inlineSVG]="'assets/images/arrow_back.svg'"></div>